import * as api from '../../api';

export const fetchAppointmentsActions = api.fetchActions('my-schedule', 'fetch-appointment');

export const getStaffListActions = api.fetchActions('scheduler', 'get-staff-list');

export const getStaffAvailabilityActions = api.fetchActions('scheduler', 'get-staff-availability');

export const saveAppointmentActions = api.fetchActions('scheduler', 'save-appointment');


export const actionTypes = {
  ...fetchAppointmentsActions.actionTypes,
  ...getStaffListActions.actionTypes,
  ...getStaffAvailabilityActions.actionTypes,
  ...saveAppointmentActions.actionTypes,
  CHANGE_DATE: 'my-schedule.change-date',
};

/**
 * Fetches a list of appointments for a given participant
 * @param {number} participantId id of participant to retrieve appointments for
 * @param {Date} start start of date range to pull list for
 * @param {Date} end end of date range to pull list for
 */
 export const fetchAppointments = (participantId, start, end) =>
   api.getThunk(`/scheduler/appointments-by-participant?participantId=${participantId}&start=${start.toISOString()}&end=${end.toISOString()}`, null, fetchAppointmentsActions);

/**
 * Changes the date displayed in the schedule view
 * @param {Moment} date a moment object representing the date to display
 */
export const changeDate = (date) => {
    return { type: actionTypes.CHANGE_DATE, date }
}

/**
 * Fetches a list of staff members for a given participant
 * @param {number} participantId 
 * @returns 
 */
export const getStaffList = (participantId) => api.getThunk(`/scheduler/staff-list-by-participant?participantId=${participantId}`, null, getStaffListActions);

const permissions = "availability";
const origin = location.origin;

/**
 * Fetches an element token for a given staff member
 * @param {number} staffId 
 * @returns 
 */
export const getStaffAvailability = (staffId) => api.getThunk(`/scheduler/staff-availability?staffId=${staffId}&permissions=${permissions}&origin=${origin}`, null, getStaffListActions);

/**
 * Saves an appointment to Event Provider and internal DB
 * @param {number} staffId 
 * @param {Appointment} appointment 
 * @returns 
 */
export const saveAppointment = (staffId, appointment) => 
  api.postThunk(`/scheduler/save-appointment?staffId=${staffId}`, appointment, saveAppointmentActions);



// WEBPACK FOOTER //
// src/scheduler/mySchedule/mySchedule.actions.js